export default __webpack_public_path__ + "static/media/goa.4bacdd02.jpg";